// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"361":"95a9acf6","374":"615cdcb1","488":"f20cbbdd"}[chunkId] + ".chunk.js";
};